// extracted by mini-css-extract-plugin
export var container = "error-module--container--sxfgT";
export var scene = "error-module--scene--Gugdw";
export var row = "error-module--row--X9nFJ";
export var cube = "error-module--cube--7sL7l";
export var face = "error-module--face--FRSaU";
export var front = "error-module--front--INL0M";
export var right = "error-module--right--iXrBJ";
export var top = "error-module--top--Ay9ng";